/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useObservable } from '@squiz/dxp-console-support';
import { SPINNER_TYPE_REGULAR, Spinner, Table, TableContent } from '@squiz/sds';
import { COMPONENT_SERVICE_STRINGS } from 'apps/component-service/src/Constants/Strings.constants';
import React, { useEffect, useState } from 'react';
import { getComponentContentService } from '../../../../Services/component-content';
import { EditContentMatrixIdentifier } from '../EditContentMatrixIdentifier/EditContentMatrixIdentifier';

/**
 * The list of content matrix identifiers.
 */
export const ContentMatrixIdentifierList = (): JSX.Element => {
  const [isLoading, setLoading] = useState(false);

  // Component content service
  const componentContentService = getComponentContentService();

  const [identifiers] = useObservable(componentContentService.matrixIdentifiers$, []);

  useEffect(() => {
    setLoading(true);
    componentContentService.getAllMatrixIdentifiers().subscribe({
      complete: () => setLoading(false),
      error: () => setLoading(false),
    });
  }, [componentContentService]);

  if (isLoading) {
    return (
      <div className="loading">
        <Spinner type={SPINNER_TYPE_REGULAR} />
      </div>
    );
  }

  const tableRows = identifiers?.map((identifier) => ({
    apiKey: identifier.apiKey,
    apiUrl: identifier.apiUrl,
    editButton: <EditContentMatrixIdentifier matrixIdentifier={identifier} />,
    name: identifier.name,
  }));

  const tableContent: TableContent = {
    columns: [
      {
        content: COMPONENT_SERVICE_STRINGS.matrixIdentifierPropName,
        key: 'name',
      },
      {
        content: COMPONENT_SERVICE_STRINGS.matrixIdentifierPropApiUrl,
        key: 'apiUrl',
      },
      {
        content: COMPONENT_SERVICE_STRINGS.matrixIdentifierPropApiKey,
        key: 'apiKey',
      },
      {
        content: '',
        key: 'editButton',
      },
    ],
    rows: tableRows || [],
  };

  return <Table isPaginated tableContent={tableContent} />;
};
